import { InsightsDuplicatesSkeleton } from '@/components/ui'
import {
  BulkEditTransactionsDialog,
  DeleteTransactionsDialog,
  EditTransactionDialog,
  type Insights,
  useFetchTransactions,
  useInsights,
  useLoadingTransactions,
  useTransactions,
} from '@/modules/projects'
import { Anomalies } from '../components'

interface AnomaliesPageProps {
  slug: string
}

export function AnomaliesPage({ slug }: AnomaliesPageProps) {
  const insights = useInsights() as Insights
  const transactions = useTransactions()
  const isLoading = useLoadingTransactions()

  useFetchTransactions(slug)

  if (isLoading || !insights) return <InsightsDuplicatesSkeleton />

  return (
    <>
      <BulkEditTransactionsDialog />
      <DeleteTransactionsDialog />
      <EditTransactionDialog />
      <Anomalies slug={slug} insights={insights} transactions={transactions} />
    </>
  )
}
